import { ExamStatus, ExamStatusUtil } from "@/api/enums/exam-status.enum";
import { formatRate } from "@/lib/utils";
import { CheckCircle2, User2, X } from "lucide-react";
import { useSessionContext } from "../session-context";

export const InfoCards = () => {
  const {
    exam: {
      successCount,
      successRate,
      status,
      preRegisteredCount,
      validRegisteredCount,
    },
  } = useSessionContext();

  // an imported session keeps its status until its documents are generated,
  // so results can be in before the status says so
  const hasResults =
    successRate !== null ||
    ExamStatusUtil.order(status) >= ExamStatusUtil.order(ExamStatus.CORRECTED);

  return hasResults ? (
    <div className="flex flex-row gap-4">
      <div className="flex flex-row justify-between gap-2 py-4 px-6 border border-gray-200 rounded-lg w-full items-center">
        <span className="text-gray-600">Taux de réussite</span>
        <span className="text-gray-950 font-semibold text-2xl">
          {formatRate(successRate)}
        </span>
      </div>
      <div className="flex flex-row justify-between gap-2 py-4 px-6 border border-gray-200 rounded-lg w-full items-center">
        <span className="text-gray-600">Candidats admis</span>
        <span className="text-gray-950 font-semibold text-2xl">
          {successCount}
        </span>
      </div>
    </div>
  ) : (
    <div className="flex flex-row gap-4">
      <div className="flex flex-col gap-2 py-4 px-6 border border-gray-200 rounded-lg w-full">
        <div className="flex flex-row justify-between">
          <span className="text-gray-600 font-medium">Nb candidats</span>
          <User2 className="text-brand-600" />
        </div>
        <span className="text-xl font-semibold text-gray-950">
          {preRegisteredCount}
        </span>
      </div>
      <div className="flex flex-col gap-2 py-4 px-6 border border-gray-200 rounded-lg w-full">
        <div className="flex flex-row justify-between">
          <span className="text-gray-600 font-medium">Candidats validés</span>
          <CheckCircle2 className="text-brand-600" />
        </div>
        <span className="text-xl font-semibold text-gray-950">
          {validRegisteredCount}
        </span>
      </div>
      <div className="flex flex-col gap-2 py-4 px-6 border border-gray-200 rounded-lg w-full">
        <div className="flex flex-row justify-between">
          <span className="text-gray-600 font-medium">
            Candidats non validés
          </span>
          <X className="text-brand-600" />
        </div>
        <span className="text-xl font-semibold text-gray-950">
          {preRegisteredCount - validRegisteredCount}
        </span>
      </div>
    </div>
  );
};

export default InfoCards;
